import { createAction } from 'redux-actions';
import revisionApi from 'api/revision-api';
import { isNullOrUndefined } from 'utils/object-utils';
import { getGeoForProjectId } from './selected-project-actions';
import revisionApis from 'api/revision-api';
export const revisionLoading = createAction('REVISION_LOADING');
export const revisionError = createAction('REVISION_ERROR');
export const revisionLoaded = createAction('REVISION_LOADED');

export const revisionHistoryLoading = createAction('REVISION_HISTORY_LOADING');
export const revisionHistoryError = createAction('REVISION_HISTORY_ERROR');
export const revisionHistoryLoaded = createAction('REVISION_HISTORY_LOADED');
export const clearStatementPageRevisionStoreAction = createAction(
  'CLEAR_STATEMENT_PAGE_REVISION_STORE_ACTION',
);

export const fetchRevision =
  (revisionId, statementId) => async (dispatch, getState) => {
    dispatch(revisionLoading());
    if (!isNullOrUndefined(revisionId)) {
      try {
        const storeData = getState().data;
        const selectedProject = storeData.selectedProject;
        const projectId = selectedProject.id;
        const selectedProjectGeoCode = dispatch(getGeoForProjectId(projectId));
        const response = await revisionApi.getRevisionRequest(
          revisionId,
          selectedProjectGeoCode,
          statementId,
        );

        if (
          !isNullOrUndefined(projectId) &&
          response.data.clientId === projectId
        ) {
          dispatch(
            revisionLoaded({
              response,
            }),
          );
        } else {
          dispatch(
            revisionError(
              new Error('You currently cannot access this statement.'),
            ),
          );
        }
      } catch (error) {
        dispatch(revisionError(error));
      }
    } else {
      dispatch(
        revisionError(new Error('You currently cannot access this statement.')),
      );
    }
  };

export const fetchRevisionHistory =
  (statementId) => async (dispatch, getState) => {
    dispatch(revisionHistoryLoading());
    try {
      const response = await revisionApis.getAllRevisionsForStatement(
        statementId,
      );
      dispatch(revisionHistoryLoaded({ response }));
    } catch (error) {
      dispatch(revisionHistoryError(error));
    }
  };

export const fetchRevisionHistoryBySocketNotification =
  ({ payload }) =>
  async (dispatch, getState) => {
    if (!payload?.statementId) {
      console.error(
        'Statement ID is missing in the payload for revision history.',
      );
      return;
    }
    const { revisionHistory } = getState().data;
    if (!revisionHistory?.isLoaded) {
      return;
    }

    const { statementId } = payload;
    try {
      const response = await revisionApis.getAllRevisionsForStatement(
        statementId,
      );
      dispatch(revisionHistoryLoaded({ response }));
    } catch (error) {
      dispatch(revisionHistoryError(error));
    }
  };
